import React from 'react'
import ViewHeader from '../../components/ViewHeader';
import { FaPlus, FaEye, FaTrashAlt, FaEdit } from 'react-icons/fa';
import { MODE_ADD, SUCCESS, NOTIF_ERROR, MODE_VIEW, MODE_EDIT, ERROR, NOTIF_SUCCESS, BLACK, BLUE, RED, DELETE_ADS, ADVERTISEMENTS, SUCCESS_BUTTON, ADD_ADS, LINK, LIST_KEY } from '../../../utils/constants';
import { connect } from 'react-redux';
import { adsOperations } from './state';
import { bindActionCreators } from 'redux'
import { SideNotification } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, DISABLED_DRAGGING, REARRANGE_DRAGGING, DELETE_MESSAGE } from '../../../utils/messages';
import DraggableTable from '../../components/DraggableTable';
import { VIEW_STORE_ROUTE } from './routes';
import { withRouter } from 'react-router-dom';
import { isNullOrUndefined } from '../../../../node_modules/util';
import ConfirmationModal from '../../components/ConfirmationModal';
import debounce from 'lodash.debounce';

class Advertisement extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            storeId: props.storeId,
            storeMode: props.storeMode,
            search: '',
            sortedList: [],
            showDeleteModal: false,
            modalId: null
        };

        this.retrieveList = debounce(this.retrieveList.bind(this), 500);
        this.deleteRow = debounce(this.deleteRow.bind(this), 500);
    }

    componentDidMount() {
        this.retrieveList();
    }

    componentWillReceiveProps(newProps){
        this.setState({sortedList: newProps.adsList})
    }

    retrieveList = () => {
        this.props.getAdsList(this.state.storeId, this.state.search)
            .then(result => {
                if (undefined !== result && SUCCESS === result.status) {
                    this.setState({ sortedList: result.data })
                } else {
                    SideNotification(NOTIF_ERROR, result.message)
                }
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    handleSearchChange = (event) => {
        this.setState({ search: event.target.value }, () => this.retrieveList());
        this.props.handleAdsSearchChange(event);
    }

    updateDraggedList = (sortedList) => {
        let oldList = [...this.state.sortedList];
        this.setState({ sortedList }, () => {
            this.props.sortDraggable(sortedList)
                .then(result => {
                    if (ERROR === result.status) {
                        //Return back to old list if error in API
                        this.setState({ sortedList: oldList })
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        })
    }

    toggleDelete = (row) => {
        this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal, modalId: isNullOrUndefined(row) ? null : row.adsId }))
    }

    deleteRow = () => {
        this.props.deleteAd(this.state.modalId)
            .then((result) => {
                if (undefined !== result && SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.retrieveList();
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    viewAd = (data, type) => {
        let params = {};

        if (MODE_EDIT === type || MODE_VIEW === type) {
            params.data = data;
            params.type = type;

            this.props.history.push({
                pathname: VIEW_STORE_ROUTE + `/${this.state.storeId}/ads/${data.adsId}`,
                state: params
            })
        } else {
            this.props.history.push(VIEW_STORE_ROUTE + `/${this.state.storeId}/ads`);
        }
    }

    render() {
        if (MODE_ADD === this.props.storeMode) {
            return <div />
        } else {
            return (
                <div>
                    <ViewHeader
                        withSearch={true}
                        title={ADVERTISEMENTS}
                        onSearchChange={this.handleSearchChange}
                        rightButtons={[
                            { variant: SUCCESS_BUTTON, label: ADD_ADS, icon: FaPlus, onClick: this.viewAd }
                        ]}
                    />
                    <DraggableTable
                        listKey={LIST_KEY}
                        draggableList={this.state.sortedList}
                        customMessage={0 < this.state.search.length ? DISABLED_DRAGGING : REARRANGE_DRAGGING}
                        tableColumns={this.props.draggableTable.tableColumns}
                        tableHeaders={this.props.draggableTable.tableHeaders}
                        updateDraggedList={this.updateDraggedList}
                        isDragDisabled={0 < this.state.search.length}
                        rowButtons={[
                            { variant: LINK, icon: FaEye, color: BLACK, onClick: this.viewAd, type: MODE_VIEW },
                            { variant: LINK, icon: FaEdit, color: BLUE, onClick: this.viewAd, type: MODE_EDIT },
                            { variant: LINK, icon: FaTrashAlt, color: RED, onClick: this.toggleDelete }
                        ]}
                    />

                    <ConfirmationModal
                        show={this.state.showDeleteModal}
                        toggleModal={this.toggleDelete}
                        title={DELETE_ADS}
                        message={DELETE_MESSAGE}
                        modalButtons={[
                            { label: "No", onClick: this.toggleDelete, variant: "secondary" },
                            { label: "Yes", onClick: this.deleteRow, variant: "danger" }
                        ]}
                    />
                </div>
            )
        }
    }

}

const mapStateToProps = (state) => {
    return {
        draggableTable: state.ads.draggableTable,
        adsList: state.ads.adsList
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getAdsList: adsOperations.getAdsList,
        sortDraggable: adsOperations.sortDraggable,
        deleteAd: adsOperations.deleteAd
    },
    dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Advertisement));